import { Identified } from "@/types/sdk-types";
import { GridSortModel } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { Location, LocationControllerApi } from "../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../utils/utils";

interface UseProviderGroupListProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  searchKey?: string;
  stateFilter?: string[];
  providerGroupId?: string | null;
  status?: boolean;
  enabled?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useLocationsList({
  gridSorting,
  pagination,
  searchKey,
  providerGroupId,
  stateFilter,
  status,
  enabled = true,
}: UseProviderGroupListProps): useBaseContent<Identified<Location>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "provider-group-location-list",
      pageSize,
      pageIndex,
      providerGroupId,
      searchKey,
      stateFilter,
      gridSorting,
      status,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled:
      providerGroupId !== undefined &&
      providerGroupId !== null &&
      (enabled ?? true),
    queryFn: async () =>
      new LocationControllerApi(getConfigObject())
        .getAllLocations(
          pageIndex,
          pageSize,
          sortBy, // sortBy
          sortDirect, // sortDirection
          status, //status
          false, //archive
          stateFilter && stateFilter?.length > 0
            ? stateFilter?.join(",")
            : undefined, //state
          searchKey, //searchString
          providerGroupId! //xTENANTID
        )
        .then((it) => it?.data),
  });
}
